import type { OnChanges, SimpleChanges } from '@angular/core';
import { Directive, ElementRef, Input, Renderer2, inject, input } from '@angular/core';

@Directive({
  selector: '[rtFollowersCounterPadding]',
  standalone: true,
})
export class FollowersCounterPaddingDirective implements OnChanges {
  private static COUNTER_PADDING_ENABLE_THRESHOLD = 99;

  private readonly renderer = inject(Renderer2);
  private readonly hostEl = inject(ElementRef);

  @Input()
  public set rtFollowersCounterPadding(followersCount: number) {
    this.followersCount = followersCount;
  }

  public readonly rtFollowersCounterPaddingEnabled = input(true);

  private followersCount = 0;

  public ngOnChanges(changes: SimpleChanges) {
    if (this.rtFollowersCounterPaddingEnabled() && 'rtFollowersCounterPadding' in changes) {
      this.onFollowersCounterChange();
    }
  }

  private onFollowersCounterChange(): void {
    if (this.followersCount > FollowersCounterPaddingDirective.COUNTER_PADDING_ENABLE_THRESHOLD) {
      this.setFollowersCounterHorizontalPadding(0.4);
    } else {
      this.setFollowersCounterHorizontalPadding(0);
    }
  }

  private setFollowersCounterHorizontalPadding(valueInRem: number): void {
    this.renderer.setStyle(this.hostEl.nativeElement, 'padding-left', `${valueInRem}rem`);
    this.renderer.setStyle(this.hostEl.nativeElement, 'padding-right', `${valueInRem}rem`);
  }
}
